import { getAxios, getOrgApiServerUrl } from "@/utils/axios";
import { AxiosResponse } from "axios";

export function callOrgMemberUpdateAPI(
  token: string | null
): Promise<AxiosResponse> {
  return getAxios(getOrgApiServerUrl()).patch("/api/org/members/update/", {
    token: token,
  });
}
